import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter ,  PreloadAllModules, withPreloading } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { headerInterceptor } from './core/interceptors/header.interceptor';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
   provideRouter(
      routes,
      withPreloading(PreloadAllModules) // ✅ Preload all lazy modules
    ),
    
    // ✅ FIXED: Combine both withFetch() and withInterceptors() in ONE provideHttpClient()
    provideHttpClient(
      withFetch(),
      withInterceptors([headerInterceptor,authInterceptor])
    ),    
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { 
        duration: 3000, 
        horizontalPosition: 'right', 
        verticalPosition: 'top' 
      }
    }
  ]
};
